import { api } from '../api/client'
import { IncidentiNis2 } from '../components/nis2/Incidenti'
import { PerimetroNis2, ProfiloNis2 } from '../components/nis2/ProfiloPerimetro'
import { QuadroProgramma } from '../components/nis2/QuadroProgramma'
import { ScadenzeNis2 } from '../components/nis2/Scadenze'
import { SuperficieEsposta } from '../components/nis2/SuperficieEsposta'
import { t } from '../i18n/lingua'
import Conformita from './Conformita'

/**
 * Il quadro NIS2 sulla pagina di conformità comune, con intorno il programma
 * che CISO e CIO portano avanti: profilo e perimetro, superficie esposta,
 * scadenze, registro degli incidenti.
 */
export default function Nis2() {
  return (
    <Conformita
      quadro={{
        framework: 'nis2',
        titolo: t('NIS2 Compliance'),
        sottotitolo: t(
          'Conformità alla Direttiva UE 2022/2555 (NIS2), valutata sui dati raccolti, con evidenza esplicita dei requisiti non misurabili.'
        ),
        notaNonMisurato: t(
          'La NIS2 include requisiti non verificabili attraverso i soli dati tecnici. Questi devono essere coperti da processi, procedure o contratti e dichiarati esplicitamente, per evitare che l’assenza di evidenze venga interpretata come conformità.'
        ),
        carica: api.nis2,
        sintesi: <QuadroProgramma />,
        programma: ({ ricarica, scrive }) => [
          {
            id: 'perimetro',
            label: t('Profilo e perimetro'),
            nodo: (
              <>
                <ProfiloNis2 scrive={scrive} />
                <PerimetroNis2 scrive={scrive} onCambiato={ricarica} />
              </>
            ),
          },
          { id: 'esposizione', label: t('Superficie esposta'), nodo: <SuperficieEsposta scrive={scrive} /> },
          { id: 'scadenze', label: t('Scadenze'), nodo: <ScadenzeNis2 scrive={scrive} /> },
          { id: 'incidenti', label: t('Incidenti'), nodo: <IncidentiNis2 scrive={scrive} /> },
        ],
      }}
    />
  )
}
